var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8AD5E8;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50,95c24.9,0,45-20.1,45-45S74.9,5,50,5S5,25.1,5,50S25.1,95,50,95z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50,5c24.8,0,45,20.2,45,45S74.8,95,50,95S5,74.8,5,50S25.2,5,50,5z M50,0C22.4,0,0,22.4,0,50s22.4,50,50,50 s50-22.4,50-50S77.6,0,50,0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.5,41.7c-2.4-6.7-7.4-12-13.6-15.1c-0.6,1.8-1.3,3.6-2.1,5.3c4.3,2.2,7.8,5.8,9.8,10.4l-7.1,2.6 c-1.3-3.4-3-6.4-4.8-9c-0.6,1-1.2,2-1.6,2.7c1.4,2.2,2.7,4.6,3.7,7.3l-8.9,3.3L40.1,19.6l-2.7,1l2,5.4c-6.2,2.6-11.1,7.3-14,13.5 c-3.1,6.6-3.4,13.9-0.9,20.8C28.4,71,38.6,78.1,50,78.1c2.7,0,5.3-0.4,7.9-1.2l2,5.4l2.7-1l-2-5.4c6.2-2.6,11.1-7.3,14-13.5 C77.7,55.9,78,48.5,75.5,41.7z M37.3,38c0.3-2.1,0.8-3.9,1.6-5.4c0.8-0.5,1.6-0.9,2.5-1.3L48.2,50l-8.9,3.2 C37.4,48,36.7,42.6,37.3,38z M30.6,41.9c1.1-2.3,2.5-4.3,4.2-6c-0.1,0.6-0.2,1.1-0.3,1.7c-0.6,4.9,0.1,10.8,2.1,16.7L29.4,57 C28,52,28.4,46.7,30.6,41.9z M30.4,59.7l7.1-2.6c2.6,6.6,6.4,12,10.4,15.3C40.3,71.6,33.5,66.7,30.4,59.7z M53.2,72.2 c-4.7-1.9-9.8-8.1-13-16.1l8.9-3.3L56,71.6C55.1,71.8,54.1,72,53.2,72.2z M61.2,69.3c-0.8,0.5-1.7,0.9-2.5,1.3l-6.8-18.7l8.9-3.2 C63.5,56.9,63.5,64.9,61.2,69.3z M69.4,60.1c-1.1,2.3-2.5,4.3-4.2,6c1-5,0.5-11.6-1.8-18.4l7.1-2.6C72,50,71.6,55.3,69.4,60.1z  M60,21.3c0-4.3-3.5-7.9-7.9-7.9s-7.9,3.5-7.9,7.9c0,6.9,7.9,18.1,7.9,18.1S60,28.2,60,21.3z M48.7,21.3c0-1.9,1.5-3.4,3.4-3.4 s3.4,1.5,3.4,3.4s-1.5,3.4-3.4,3.4C50.3,24.7,48.7,23.1,48.7,21.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifIcon);
export default __webpack_public_path__ + "static/media/wifIcon.7a1b3c13ff002e79d45b962d4d7fe972.svg";
export { ForwardRef as ReactComponent };